<template>
  <div class="myNav">
    <img src="../assets/nav/yz_nav_fh.png" alt="" @click="$router.back()" />
    <h3>{{ title }}</h3>
    <div class="right-nr">
      <div v-if="textright" class="lr-right" @click="clickRight">
        {{ textright }}
      </div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
import { reactive } from "vue";
import { useRouter } from "vue-router";
export default {
  name: "nav01",
  props: {
    title: {
      type: String,
      default: "标题",
    },
    textright: {
      type: String,
      // default: "右边"
    },
  },
  setup(props, context) {
    const router = useRouter();
    const state = reactive({});
    const clickRight = () => {
      context.emit("clickRight");
    };
    return {
      state,
      clickRight,
    };
  },
};
</script>
<style>
.myNav {
  width: 100%;
  padding: 0 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: calc(60px + constant(safe-area-inset-top));
  padding-top: calc(60px + env(safe-area-inset-top));
  position: fixed;
}
.myNav img {
  width: 60px;
  height: 60px;
}
.myNav h3 {
  font-size: 32px;
  font-weight: bold;
  color: #fff;
}
.myNav .right-nr {
  width: 60px;
  height: 60px;
}
</style>
